import { Partner } from './partner.model';
import { ShortnedLinkWithAffiliation } from './shortened-link-with-affiliation';
import { ShortnedLink } from './shortened-link';
import { AffiliationPartner } from './affiliation-partner.model';
import { User } from './user.model';
import { BaseEntity } from "./base-entity.model";

import * as firebase from "firebase/app";
import "firebase/firestore";

export enum Status {
  TODO = "TODO",
  IN_PROGRESS = "IN_PROGRESS",
  PROCESSING = "PROCESSING",
  IN_REVIEW = "IN_REVIEW",
  DONE = "DONE"
}

export enum ItineraryActivityType {
  FOOD = "FOOD",
  DISCOVER = "DISCOVER",
  ACCOMODATION = "ACCOMODATION",
  CAR = "CAR",
  MOTO = "MOTO",
  CAMPER = "CAMPER",
  BIKE = "BIKE",
  SCOOTER = "SCOOTER",
  QUAD = "QUAD",
  FLIGHT = "FLIGHT",
  BUS = "BUS",
  FERRY = "FERRY",
  TRAIN = "TRAIN",
  WALK = "WALK",
  METRO = "METRO",
  TRAM = "TRAM",
  TAXY = "TAXY",
  NIGHTLIFE = "NIGHTLIFE",
  SHOPPING = "SHOPPING",
  FREETIME = "FREETIME"
}

export class ItineraryActivityTypeData {
  static readonly FOOD = new ItineraryActivityTypeData(
    ItineraryActivityType.FOOD,
    "Food",
    "restaurant"
  );
  static readonly DISCOVER = new ItineraryActivityTypeData(
    ItineraryActivityType.DISCOVER,
    "Discover",
    "map"
  );
  static readonly ACCOMODATION = new ItineraryActivityTypeData(
    ItineraryActivityType.ACCOMODATION,
    "Alloggio",
    "hotel"
  );
  static readonly CAR = new ItineraryActivityTypeData(
    ItineraryActivityType.CAR,
    "Auto",
    "directions_car"
  );
  static readonly MOTO = new ItineraryActivityTypeData(
    ItineraryActivityType.MOTO,
    "Moto",
    "motorcycle"
  );
  static readonly CAMPER = new ItineraryActivityTypeData(
    ItineraryActivityType.CAMPER,
    "Camper",
    "directions_car"
  );
  static readonly BIKE = new ItineraryActivityTypeData(
    ItineraryActivityType.BIKE,
    "Bicicletta",
    "directions_bike"
  );
  static readonly SCOOTER = new ItineraryActivityTypeData(
    ItineraryActivityType.SCOOTER,
    "Scooter",
    "motorcycle"
  );
  static readonly QUAD = new ItineraryActivityTypeData(
    ItineraryActivityType.QUAD,
    "Quad",
    "directions_car"
  );
  static readonly FLIGHT = new ItineraryActivityTypeData(
    ItineraryActivityType.FLIGHT,
    "Volo",
    "flight"
  );
  static readonly BUS = new ItineraryActivityTypeData(
    ItineraryActivityType.BUS,
    "Bus",
    "directions_bus"
  );
  static readonly FERRY = new ItineraryActivityTypeData(
    ItineraryActivityType.FERRY,
    "Nave",
    "directions_boat"
  );
  static readonly TRAIN = new ItineraryActivityTypeData(
    ItineraryActivityType.TRAIN,
    "Treno",
    "train"
  );
  static readonly WALK = new ItineraryActivityTypeData(
    ItineraryActivityType.WALK,
    "a Piedi",
    "directions_walk"
  );
  static readonly METRO = new ItineraryActivityTypeData(
    ItineraryActivityType.METRO,
    "Metro",
    "directions_subway"
  );
  static readonly TRAM = new ItineraryActivityTypeData(
    ItineraryActivityType.TRAM,
    "Tram",
    "tram"
  );
  static readonly TAXY = new ItineraryActivityTypeData(
    ItineraryActivityType.TAXY,
    "Taxy",
    "local_taxi"
  );
  static readonly NIGHTLIFE = new ItineraryActivityTypeData(
    ItineraryActivityType.NIGHTLIFE,
    "Nightlife",
    "nights_stay"
  );
  static readonly SHOPPING = new ItineraryActivityTypeData(
    ItineraryActivityType.SHOPPING,
    "Shopping",
    "shopping_cart"
  );
  static readonly FREETIME = new ItineraryActivityTypeData(
    ItineraryActivityType.FREETIME,
    "Tempo Libero",
    "access_time"
  );

  private constructor(
    public readonly key: ItineraryActivityType,
    public readonly label: string,
    public readonly icon: string
  ) { }

  static values(): ItineraryActivityTypeData[] {
    return [ItineraryActivityTypeData.FOOD, ItineraryActivityTypeData.DISCOVER, ItineraryActivityTypeData.ACCOMODATION, ItineraryActivityTypeData.CAR, ItineraryActivityTypeData.MOTO, ItineraryActivityTypeData.CAMPER, ItineraryActivityTypeData.BIKE, ItineraryActivityTypeData.SCOOTER, ItineraryActivityTypeData.QUAD, ItineraryActivityTypeData.FLIGHT, ItineraryActivityTypeData.BUS, ItineraryActivityTypeData.FERRY, ItineraryActivityTypeData.TRAIN, ItineraryActivityTypeData.WALK, ItineraryActivityTypeData.METRO, ItineraryActivityTypeData.TRAM, ItineraryActivityTypeData.TAXY, ItineraryActivityTypeData.NIGHTLIFE, ItineraryActivityTypeData.SHOPPING, ItineraryActivityTypeData.FREETIME];
  }

  static get(key: ItineraryActivityType) {
    const values = ItineraryActivityTypeData.values();
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if (element.key === key) return element;
    }
    return null;
  }

  toString() {
    return this.key;
  }
}

export enum CarType {
  CAR = "CAR",
  MOTO = "MOTO",
  CAMPER = "CAMPER",
  BIKE = "BIKE",
  SCOOTER = "SCOOTER",
  QUAD = "QUAD"
}

export class CarTypeData {
  static readonly CAR = new CarTypeData(
    CarType.CAR,
    "Auto",
    "La tua Auto",
    "directions_car"
  );

  static readonly MOTO = new CarTypeData(
    CarType.MOTO,
    "Moto",
    "La tua Moto",
    "directions_bike"
  );

  static readonly CAMPER = new CarTypeData(
    CarType.CAMPER,
    "Camper",
    "Il tuo Camper",
    "directions_car"
  );

  static readonly BIKE = new CarTypeData(
    CarType.BIKE,
    "Bicicletta",
    "La tua Bicicletta",
    "directions_bike"
  );

  static readonly SCOOTER = new CarTypeData(
    CarType.SCOOTER,
    "Scooter",
    "Il tuo scooter",
    "directions_bike"
  );

  static readonly QUAD = new CarTypeData(
    CarType.QUAD,
    "Quad",
    "Il tuo Quad",
    "directions_car"
  );

  private constructor(
    public readonly key: CarType,
    public readonly label: string,
    public readonly title: string,
    public readonly icon: string
  ) { }

  static values(): CarTypeData[] {
    return [CarTypeData.CAR, CarTypeData.MOTO, CarTypeData.CAMPER, CarTypeData.BIKE, CarTypeData.SCOOTER, CarTypeData.QUAD];
  }

  static get(key: CarType) {
    const values = CarTypeData.values();
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if (element.key === key) return element;
    }
    return null;
  }

  toString() {
    return this.key;
  }
}


export enum AccomodationType {
  HOTEL = "HOTEL",
  APPARTAMENTO = "APPARTAMENTO",
  TENDA = "TENDA",
  CAMPEGGIO = "CAMPEGGIO",
  BED_AND_BREAKFAST = "BED_AND_BREAKFAST",
  OSTELLO = "OSTELLO",
}

export class AccomodationTypeData {
  static readonly HOTEL = new AccomodationTypeData(
    AccomodationType.HOTEL,
    "Hotel"
  );

  static readonly APPARTAMENTO = new AccomodationTypeData(
    AccomodationType.APPARTAMENTO,
    "Appartamento"
  );

  static readonly TENDA = new AccomodationTypeData(
    AccomodationType.TENDA,
    "Tenda"
  );

  static readonly CAMPEGGIO = new AccomodationTypeData(
    AccomodationType.CAMPEGGIO,
    "Campeggio"
  );

  static readonly BED_AND_BREAKFAST = new AccomodationTypeData(
    AccomodationType.BED_AND_BREAKFAST,
    "Bed and Breakfast"
  );

  static readonly OSTELLO = new AccomodationTypeData(
    AccomodationType.OSTELLO,
    "Ostello"
  );

  private constructor(
    public readonly key: AccomodationType,
    public readonly label: string
  ) { }

  static values(): AccomodationTypeData[] {
    return [AccomodationTypeData.HOTEL, AccomodationTypeData.APPARTAMENTO, AccomodationTypeData.TENDA, AccomodationTypeData.CAMPEGGIO, AccomodationTypeData.BED_AND_BREAKFAST, AccomodationTypeData.OSTELLO];
  }

  static get(key: AccomodationType) {
    const values = AccomodationTypeData.values();
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if (element.key === key) return element;
    }
    return null;
  }

  toString() {
    return this.key;
  }
}

export interface ItineraryExpenses {
  total: number;
  items: ItineraryExpenseItem[];
}

export interface ItineraryExpenseItem {
  label: string;
  icon: string;
  total: number;
  items: ItineraryExpenseSubItem[];
}

export interface ItineraryExpenseSubItem {
  label: string; value: number;
}

export interface ItineraryImage {
  url: string;
  ref: string;
}

export interface Place {
  id?: string;
  name?: string;
  address?: string;
  position: firebase.firestore.GeoPoint;
}

export interface TransportationReservationRoute {
  id: string;
  title: string;
  company: string;
  code: string;
  from: string;
  fromDetail: string;
  fromCode: string;
  fromPlace: Place;
  to: string;
  toDetail: string;
  toCode: string;
  toPlace: Place;
  start: firebase.firestore.Timestamp;
  end: firebase.firestore.Timestamp;
  stops: string[];
  duration: { hours: number, minutes: number };
}

export interface TransportationReservation {
  id: string;
  notes: string;
  link: ShortnedLinkWithAffiliation;
  partner: AffiliationPartner;
  price: number;
  routes: TransportationReservationRoute[];
}

export interface CarReservation {
  id: string;
  company: string;
  title: string;
  description: string;
  from: string;
  fromDetail: string;
  fromPlace: Place;
  to: string;
  toDetail: string;
  toPlace: Place;
  start: firebase.firestore.Timestamp;
  end: firebase.firestore.Timestamp;
  notes: string;
  link: ShortnedLinkWithAffiliation;
  partner: AffiliationPartner;
  price: number;
  image: ItineraryImage;
  type: CarType;
}

export interface AccomodationReservationProposal {
  name: string;
  description: string;
  stars: number;
  price: number;
  link: ShortnedLinkWithAffiliation;
  partner: AffiliationPartner;
  image: ItineraryImage;
  type: AccomodationType;
  favorite: boolean;
  place: Place;
}

export interface AccomodationReservation {
  id: string;
  start: firebase.firestore.Timestamp;
  end: firebase.firestore.Timestamp;
  city: string;
  proposals: AccomodationReservationProposal[];
}
export interface DayActivity {
  type: ItineraryActivityType;
  time: firebase.firestore.Timestamp;
  title: string;
  image: ItineraryImage;
  description: string;
  link: ShortnedLink;
  price: number;
  priceLabel: string;
  reservationId: string;
  place: Place;
  duration: { hours: number, minutes: number };
}

export interface PointOfInterest {
  title: string;
  image: ItineraryImage;
  description: string;
  link: ShortnedLink;
  place: Place;
  generated?: boolean;
}

export interface Day {
  date: firebase.firestore.Timestamp;
  title: string;
  description: string;
  link: ShortnedLink;
  activities: DayActivity[];
  pois: PointOfInterest[];
}

interface RenderConfig {
  hideDates: boolean;
  hideUpsells: boolean;
}

export class Itinerary extends BaseEntity {
  locale: string;
  plan?: string;
  createdAt?: firebase.firestore.Timestamp;
  link: ShortnedLink;
  customer: firebase.firestore.DocumentReference;
  customerData: User;
  assignee: firebase.firestore.DocumentReference;
  assigneeData: User;
  proposedAssignees: firebase.firestore.DocumentReference[];
  cart: firebase.firestore.DocumentReference;
  coupon: firebase.firestore.DocumentReference;
  title: string;
  start: firebase.firestore.Timestamp;
  end: firebase.firestore.Timestamp;
  status: Status;
  coverImage: ItineraryImage;
  secondaryImage: ItineraryImage;
  destination: string;
  description: string;
  additionalInfo: string;
  npax: number;
  archived: boolean;
  test: boolean;
  preferences: any; // TODO
  reservations: {
    flights: TransportationReservation[];
    accomodations: AccomodationReservation[];
    cars: CarReservation[]; // auto, camper, moto
    trains: TransportationReservation[];
    buses: TransportationReservation[];
    ferries: TransportationReservation[];
  };
  partner: Partner;
  renderConfig: RenderConfig;
  days: Day[];
  expenses: {
    min: ItineraryExpenses,
    max: ItineraryExpenses,
  };
  upsells: {
    revisioni?: ShortnedLink,
    assistenza?: ShortnedLink,
    prenotazione?: ShortnedLink
  };
}
